export interface TarotCard {
  card_id: number;
  card_name: string;
  card_name_th?: string; // ✅ NEW FIELD (Thai name)
  image_url: string;
}

// export const tarotCards: TarotCard[] = [
const suits = ["Cups", "Wands", "Swords", "Pentacles"];

const ranks = [
  "Ace",
  "II",
  "III",
  "IV",
  "V",
  "VI",
  "VII",
  "VIII",
  "IX",
  "X",
  "Page",
  "Knight",
  "Queen",
  "King",
];

// ✅ Thai mappings (added, no logic changed)
const suitThai: Record<string, string> = {
  Cups: "ถ้วย",
  Wands: "ไม้เท้า",
  Swords: "ดาบ",
  Pentacles: "เหรียญ",
};

const rankThai: Record<string, string> = {
  Ace: "หนึ่ง",
  II: "สอง",
  III: "สาม",
  IV: "สี่",
  V: "ห้า",
  VI: "หก",
  VII: "เจ็ด",
  VIII: "แปด",
  IX: "เก้า",
  X: "สิบ",
  Page: "เด็กถือ",
  Knight: "อัศวิน",
  Queen: "ราชินี",
  King: "ราชา",
};

const generateMinorArcana = () => {
  let id = 23; // Major Arcana are 0–21
  const minor: any = [];

  suits.forEach((suit) => {
    ranks.forEach((rank, index) => {
      minor.push({
        card_id: id++,
        arcana: "Minor",
        suit: suit,
        rank: rank,
        card_name: `${rank} of ${suit}`,
        card_name_th: `${rankThai[rank]} แห่ง${suitThai[suit]}`, // ✅ NEW FIELD
        image_url: `/cards/${suit}${index + 1}.png`,
      });
    });
  });

  return minor;
};

const majorArcana = [
  {
    card_id: 0,
    arcana: "Major",
    card_name: "The Fool",
    card_name_th: "ไพ่คนโง่",
    image_url: "/cards/fool.png",
  },
  {
    card_id: 1,
    arcana: "Major",
    card_name: "The Magician",
    card_name_th: "ไพ่นักมายากล",
    image_url: "/cards/magician.png",
  },
  {
    card_id: 2,
    arcana: "Major",
    card_name: "The High Priestess",
    card_name_th: "ไพ่มหาปุโรหิตหญิง",
    image_url: "/cards/The-High-Priestess.png",
  },
  {
    card_id: 3,
    arcana: "Major",
    card_name: "The Empress",
    card_name_th: "ไพ่จักรพรรดินี",
    image_url: "/cards/Empress.png",
  },
  {
    card_id: 4,
    arcana: "Major",
    card_name: "The Emperor",
    card_name_th: "ไพ่จักรพรรดิ",
    image_url: "/cards/The-Emperor.png",
  },
  {
    card_id: 5,
    arcana: "Major",
    card_name: "The Hierophant",
    card_name_th: "ไพ่สังฆราช",
    image_url: "/cards/Hierophant.png",
  },
  {
    card_id: 6,
    arcana: "Major",
    card_name: "The Lovers",
    card_name_th: "ไพ่คนรัก",
    image_url: "/cards/lovers.png",
  },
  {
    card_id: 7,
    arcana: "Major",
    card_name: "The Chariot",
    card_name_th: "ไพ่รถศึก",
    image_url: "/cards/The-Chariot.png",
  },
  {
    card_id: 8,
    arcana: "Major",
    card_name: "Strength",
    card_name_th: "ไพ่พลัง",
    image_url: "/cards/Strength.png",
  },
  {
    card_id: 9,
    arcana: "Major",
    card_name: "The Hermit",
    card_name_th: "ไพ่ฤๅษี",
    image_url: "/cards/hermit.png",
  },
  {
    card_id: 10,
    arcana: "Major",
    card_name: "Wheel of Fortune",
    card_name_th: "ไพ่กงล้อแห่งโชคชะตา",
    image_url: "/cards/Wheel-of-Fortune.png",
  },
  {
    card_id: 11,
    arcana: "Major",
    card_name: "Justice",
    card_name_th: "ไพ่ความยุติธรรม",
    image_url: "/cards/Justice.png",
  },
  {
    card_id: 12,
    arcana: "Major",
    card_name: "The Hanged Man",
    card_name_th: "ไพ่ชายแขวนคอ",
    image_url: "/cards/Hanged-Man.png",
  },
  {
    card_id: 13,
    arcana: "Major",
    card_name: "Death",
    card_name_th: "ไพ่ความตาย",
    image_url: "/cards/Death.png",
  },
  {
    card_id: 14,
    arcana: "Major",
    card_name: "Temperance",
    card_name_th: "ไพ่ความพอดี",
    image_url: "/cards/Temperance.png",
  },
  {
    card_id: 15,
    arcana: "Major",
    card_name: "The Devil",
    card_name_th: "ไพ่ปีศาจ",
    image_url: "/cards/The-Devil.png",
  },
  {
    card_id: 16,
    arcana: "Major",
    card_name: "The Tower",
    card_name_th: "ไพ่หอคอย",
    image_url: "/cards/tower.png",
  },
  {
    card_id: 17,
    arcana: "Major",
    card_name: "The Star",
    card_name_th: "ไพ่ดวงดาว",
    image_url: "/cards/star.png",
  },
  {
    card_id: 18,
    arcana: "Major",
    card_name: "The Moon",
    card_name_th: "ไพ่พระจันทร์",
    image_url: "/cards/moon.png",
  },
  {
    card_id: 19,
    arcana: "Major",
    card_name: "The Sun",
    card_name_th: "ไพ่พระอาทิตย์",
    image_url: "/cards/sun.png",
  },
  {
    card_id: 20,
    arcana: "Major",
    card_name: "Judgement",
    card_name_th: "ไพ่พิพากษา",
    image_url: "/cards/Judgement.png",
  },
  {
    card_id: 21,
    arcana: "Major",
    card_name: "The World",
    card_name_th: "ไพ่โลก",
    image_url: "/cards/The-World.png",
  },
];

export const tarotCards: TarotCard[] = [
  ...majorArcana,
  ...generateMinorArcana(),
];
